<template>
  <div class="relative w-full pr-3" :class="searchBarWidthClass">
    <img
      src="../../../public/assets/icons/search.svg"
      class="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6"
      alt="Search Icon"
    />
    <img
      v-if="localSearchTerm"
      src="../../../public/assets/icons/cross.svg"
      class="absolute right-7 top-1/2 transform -translate-y-1/2 w-3 h-3 hover:cursor-pointer"
      alt="Cross Icon"
      @mousedown.prevent
      @click="clearSearch"
    />
    <input
      v-model="localSearchTerm"
      type="text"
      class="text-black placeholder:text-[#637083] w-full pl-11 h-[48px] bg-white border-[2px] border-grey-40 text-20 leading-32 font-aktiv-grotesk rounded-xl hover:border-black focus:border-black outline-none"
      :placeholder="$t('copy.resourcesPage.searchBar')"
      @input="onInput"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
  </div>
</template>

<script>
import Fuse from 'fuse.js';

export default {
  props: {
    assets: {
      type: Object,
      required: true,
    },
    searchTerm: {
      type: String,
      default: '',
    },
    animateWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSearchTerm: this.searchTerm,
      ResultsCount: 0,
      searchResults: {
        links: [],
        pdf: [],
        books: [],
        quotes: [],
      },
      isSearching: false,
      debounceTimer: null,
      isFocused: false,
    };
  },
  computed: {
    searchBarWidthClass() {
      if (!this.animateWidth) return '';
      return this.isFocused
        ? 'transition-[max-width] duration-300 ease-in-out md:max-w-[720px]'
        : 'transition-[max-width] duration-300 ease-in-out md:max-w-[400px]';
    },
  },
  watch: {
    searchTerm(newTerm) {
      this.localSearchTerm = newTerm;
      this.onSearch();
    },
    localSearchTerm(newTerm) {
      this.$emit('update:searchTerm', newTerm);
    },
  },
  beforeUnmount() {
    clearTimeout(this.debounceTimer);
  },
  methods: {
    onInput() {
      clearTimeout(this.debounceTimer);
      this.$emit('searching', true);
      this.debounceTimer = setTimeout(() => {
        this.onSearch();
      }, 500);
    },
    onSearch() {
      const fuseLink = new Fuse(this.assets.links, {
        keys: ['title', 'searchTerms', 'description', 'preacher', 'topics'],
        minMatchCharLength: 1,
        threshold: 0.1,
        ignoreLocation: true,
      });
      const fusePdf = new Fuse(this.assets.pdf, {
        keys: ['slug', 'searchTerms', 'topics'],
        minMatchCharLength: 1,
        threshold: 0.1,
        ignoreLocation: true,
      });
      const fuseBooks = new Fuse(this.assets.books, {
        keys: ['title', 'searchTerms', 'description', 'topics'],
        minMatchCharLength: 1,
        threshold: 0.1,
        ignoreLocation: true,
      });
      const fuseQuotes = new Fuse(this.assets.quotes, {
        keys: ['title', 'searchTerms', 'description', 'topics'],
        minMatchCharLength: 1,
        threshold: 0.1,
        ignoreLocation: true,
      });
      const fuseLinkResult = fuseLink.search(this.localSearchTerm);
      const fusePdfResult = fusePdf.search(this.localSearchTerm);
      const fuseBooksResult = fuseBooks.search(this.localSearchTerm);
      const fuseQuotesResult = fuseQuotes.search(this.localSearchTerm);

      // Data transformation
      const pdfResult = fusePdfResult.map(result => {
        return {
          ...result.item,
        };
      });
      const linksResult = fuseLinkResult.map(result => {
        return {
          ...result.item,
        };
      });
      const booksResult = fuseBooksResult.map(result => {
        return {
          ...result.item,
        };
      });
      const quotesResult = fuseQuotesResult.map(result => {
        return {
          ...result.item,
        };
      });
      this.searchResults = {
        links: linksResult,
        pdf: pdfResult,
        books: booksResult,
        quotes: quotesResult,
      };
      this.ResultsCount =
        linksResult.length + pdfResult.length + booksResult.length + quotesResult.length;
      if (this.searchTerm.trim() === '') {
        this.isSearching = false;
      } else {
        this.isSearching = true;
      }
      // emit for debounced loading state
      this.$emit('searching', false);
      this.$emit(
        'submit-search',
        this.searchResults,
        this.localSearchTerm,
        this.ResultsCount,
        this.isSearching,
      );
    },
    clearSearch() {
      clearTimeout(this.debounceTimer);
      this.localSearchTerm = '';
      this.searchResults = {
        links: [],
        pdf: [],
        books: [],
        quotes: [],
      };
      this.ResultsCount = 0;
      this.isSearching = false;
      this.$emit('searching', false);
      this.$emit('submit-search', this.searchResults, this.localSearchTerm, 0, this.isSearching);
    },
  },
};
</script>

<style scoped>
.searchBar {
  color: #637083;
  border-width: 1px;
  border-radius: 10px;
  outline-style: none;
}

.searchBar:focus {
  box-shadow: 0 0 2pt 2pt rgba(0, 102, 255, 0.8);
}
</style>
